module.exports = __webpack_public_path__ + "fonts/b391d0e9dd86ead6604092b134e407bf-Roboto-Italic.ttf";